import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/lib/utils";

export interface SecondaryButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean;
  size?: "default" | "lg";
  /** Opt out of wrapping. Only for short, guaranteed-fitting labels. */
  nowrap?: boolean;
}

export const SecondaryButton = React.forwardRef<HTMLButtonElement, SecondaryButtonProps>(
  ({ className, asChild = false, size = "default", nowrap = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        ref={ref}
        className={cn(
          "inline-flex max-w-full items-center justify-center gap-2 text-center",
          nowrap ? "whitespace-nowrap" : "whitespace-normal break-words",
          "bg-transparent border border-bronze-600 text-cream-50 font-sans",
          "font-semibold uppercase tracking-[0.05em] transition-colors cursor-pointer",
          "hover:bg-bronze-400 hover:text-navy-900 hover:border-bronze-400",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-bronze-400",
          "focus-visible:ring-offset-2 focus-visible:ring-offset-navy-900",
          "disabled:opacity-50 disabled:pointer-events-none",
          size === "lg" ? "min-h-12 px-7 py-3 text-sm" : "min-h-10 px-5 py-2 text-[13px]",
          className,
        )}
        style={{ borderRadius: "var(--radius-button)" }}
        {...props}
      />
    );
  },
);
SecondaryButton.displayName = "SecondaryButton";

export default SecondaryButton;